/* 
    [구매자 데이터]
    1. 구매자 번호
    2. 구매자 성별
    3. 구매자 연령
    4. 상품 번호 리스트(FK) - 상품 데이터 기준
    5. 상품 개수 리스트(총 개수 구하기) - 이 기준으로 총 물품 대금과 이달 매출을 구함
*/

const testBuyerData = [
    {
        buyerNo : 1,
        buyerGender : "male",
        buyerAge : 20,
        productNo : [1, 2, 3],
        productCnt : [10, 20, 30],
    },
    {
        buyerNo : 2,
        buyerGender : "female",
        buyerAge : 25,
        productNo : [1, 2, 3],
        productCnt : [20, 30, 70],
    },
    {
        buyerNo : 3,
        buyerGender : "male",
        buyerAge : 30,
        productNo : [1, 2, 3],
        productCnt : [23, 42, 12],
    },
    {
        buyerNo : 4,
        buyerGender : "male",
        buyerAge : 35,
        productNo : [1, 2, 3],
        productCnt : [11, 6, 2],
    },
    {
        buyerNo : 5,
        buyerGender : "female",
        buyerAge : 23,
        productNo : [1, 2, 3],
        productCnt : [23, 64, 43],
    },
    {
        buyerNo : 6,
        buyerGender : "male",
        buyerAge : 28,
        productNo : [1, 2, 3],
        productCnt : [21, 11, 6],
    },
];

export default testBuyerData;